import {
  GetPluginMetadataSchemaRequest,
  PluginConfigurationApi,
  PluginType,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getApi = () => BackOfficeDataServiceAPI.getBackOfficeApi(PluginConfigurationApi)

const getMetadataSchema = async (
  type: PluginType,
  refId?: string,
  promotionTrigger?: string,
): Promise<Record<string, unknown>> => {
  const request: GetPluginMetadataSchemaRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    type,
    refId,
    promotionTrigger,
  }

  return await getApi().getPluginMetadataSchema(request)
}

export const PluginMetadataServiceAPI = {
  getMetadataSchema,
}
